import { AsyncState } from 'widgets-for-react'
import { ImageData } from '../../image/imageState'
import { loadBlogTeasers } from './blogTeasersApi'

export type BlogTeasersState = AsyncState<BlogTeasersData>

export type BlogTeasersData = BlogTeaserData[]

export type BlogTeaserData = {
  Id: number
  Path: string
  HeaderTitle: string
  HeaderDescription: string
  HeaderImage: ImageData
  PublicationDateBegin: string
}

export const initialBlogTeasersState = (
  apicall: () => Promise<any>
): BlogTeasersState => loadBlogTeasers(apicall)
